export default {
  SET_DOCTOR_LIST(state, doctors) {
    state.doctorList = doctors;
  },
  SET_OTP_DETAILS(state, otp) {
    state.otpDetails = otp
  },
  SET_CHECK_IN_LOG_TYPE_ID(state, typeId) {
    state.auth.user.checkInLogTypeId = typeId
  },
  SET_ROOT(state, root) {

    state.rootpage = root
  },
  SET_LOGIN_LOADING(state, loginLoading) {

    state.loginLoading = loginLoading
  },
  SET_CALL_LOADING(state,value){
    state.callLoading=value
  }

}